import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const EcommerceSEOAndMarketingInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="E-commerce SEO and Marketing in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Visibility</Subheading>}
        heading={
          <Heading>
            E-commerce <span tw="text-primary-500">SEO & Marketing</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide expert e-commerce SEO and marketing
            services in **Dubai**, driving traffic, increasing rankings, and
            growing your sales. Let us elevate your online store with proven
            strategies.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1533750516457-a7f992034fec?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Grow Your Store Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="E-commerce Success in Dubai"
        description="We optimize and market your store for maximum impact."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Higher Rankings",
            description: "Boost your store on Google with expert SEO.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Increased Sales",
            description: "Targeted marketing drives conversions.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Tailored Strategies",
            description: "Custom plans for your e-commerce goals.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimization",
            description: "SEO that excels on all devices.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Data-Driven Results",
            description: "Analytics-backed marketing campaigns.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Experts",
            description: "Dubai’s top SEO and marketing team.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our SEO & Marketing Process"
        description={
          <Description>
            We grow your e-commerce presence with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Analyze your market and competitors.</li>
              <li>SEO: Optimize keywords, content, and technicals.</li>
              <li>Marketing: Launch ads, social, and email campaigns.</li>
              <li>Tracking: Monitor rankings, traffic, and sales.</li>
              <li>Refinement: Adjust strategies for peak performance.</li>
              <li>Reporting: Deliver clear, actionable insights.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1566241440091-ec10de8db2e1?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="SEO & Marketing Wins in Dubai"
        description="Our strategies deliver measurable growth."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Increased revenue by 200% in 4 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Top Rankings",
            description: "Achieved #1 on Google for key terms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "95% satisfaction with campaign results.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Stand Out?</Subheading>}
        heading="E-commerce SEO & Marketing in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for e-commerce SEO and marketing in
            Dubai. Drive traffic, boost rankings, and grow your sales—contact us
            today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1502945015378-0e284ca1a5be?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
